

exports.__esModule = true;

var _squid = require('squid');

var _angular = require('angular');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// wrapper class which looks like password black dot
var PASSWORD_DOT_CLASS = 'passwordDot';

// wrapper class which looks like an empty grey dot
var DEFAULT_DOT_CLASS = 'defaultDot';

// delay after which input becomes a password dot, so user can see what number was entered for 1 sec
var DELAY = 600;

// back key code
var BACK_KEY = 0x8;

// check if entered pin combination is valid
var isPinValid = function isPinValid(value) {
    var onlyNumbers = /^\d{4}$/i;
    var consecutiveDigits = /^0123|1234|2345|3456|4567|5678|6789$/i;
    var commonPattern = /^0246|1357|2468|3579$/i;
    var repeatingDigits = /^([0-9])\1*$/i;
    return onlyNumbers.test(value) && !consecutiveDigits.test(value) && !commonPattern.test(value) && !repeatingDigits.test(value);
};

// check if entered input value is number before proceeding to the next input
var isKeyValid = function isKeyValid(val) {
    return (/^\d{1}/.test(val)
    );
};

// get wrapper of input element
var getWrapperElement = function getWrapperElement(el) {
    return angular.element(el).parent();
};

/**
 * This component is for setting PIN number for in-store purchases in tokenized flows (e.g Google Pay / Samsung Pay)
 * It's used in Hermes -> pages/xo-pin-setup
 * After Pin is set -> done callback is being called
 * and pin is getting saved in $TokenizedWalletPinModel and on the xo-review page there is POST API call to save it in the database (see '/api/pin/tokenizedWallet/:id')
 */
exports['default'] = _squid.$Component.extend('$xoMobilePin', {
    tag: 'xo-mobile-pin',
    template: _template2['default'],
    props: {
        /**
         * callback function passed from xo-pin-setup page in Hermes
         * which is being called when all 4 pin numbers are set
         * (even after first attempt or if it's a too simple combination)
         *
         */
        done: {
            type: 'var',
            required: false
        }
    },

    actions: {
        /**
         * Every time key is released we need to check if all 4 digits are set and so call done function
         * otherwise move cursor to the right if entered value is a number
         */
        releaseKey: function releaseKey(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            if (eventObj && eventObj.keyCode === BACK_KEY) {
                return;
            }
            var currEle = document.getElementById(currID);
            var currentValue = this.pinvalue[currID];

            if (this.isDone()) {
                currEle.blur();
                var pin = this.getPin();
                this.props.done(pin);
            }
            if (isKeyValid(currentValue)) {
                this.moveCursor(currID, 'right', false);
            }
        },

        /**
         * Every time key is pressed check if it was a back key
         * if yes -> move cursor to the left to the previous input
         */
        pressedKey: function pressedKey(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;

            if (eventObj && eventObj.keyCode === BACK_KEY) {
                this.moveCursor(currID, 'left', true);
            }
        },

        /**
         * Every time input is focused:
         * 1. reset input value and store value
         * 2. remove password dot class and default dot class from the parent wrapper
         */
        onFocus: function onFocus(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            var currEle = document.getElementById(currID);

            this.pinvalue[currID] = '';
            currEle.value = '';

            getWrapperElement(currEle).removeClass(PASSWORD_DOT_CLASS);
            getWrapperElement(currEle).removeClass(DEFAULT_DOT_CLASS);
        },

        /**
         * Every time input is unfocused:
         * 1. if current value is empty -> add default dot class to the parent wrapper
         * 2. otherwise add password dot class to the parent wrapper with a delay so user can see an entered value
         */
        onBlur: function onBlur(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            var currentValue = eventObj && eventObj.currentTarget.value;
            var currEle = document.getElementById(currID);
            if (!currentValue) {
                getWrapperElement(currEle).addClass(DEFAULT_DOT_CLASS);
            }
            if (!this.doingReset && currentValue) {
                (0, _angular.$timeout)(function () {
                    getWrapperElement(currEle).addClass(PASSWORD_DOT_CLASS);
                    currEle.value = '';
                }, DELAY);
            }
        },

        /**
         * since we have pseudo classes to render password dot / default dot on top of the inout ->
         * make sure element under the dot is focused every time there is a click
         */
        onWrapperClick: function onWrapperClick(eventObj) {
            angular.element(eventObj.currentTarget).find('input').focus();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            // store of pin values
            this.pinvalue = {};
            this.doingReset = false;
            this.fields = ['field1', 'field2', 'field3', 'field4'];

            // get pin result and check if pin is too simple
            this.getPin = function () {
                var result = { value: '', error: '' };
                _this.fields.forEach(function (fieldName) {
                    result.value = result.value + String(_this.pinvalue[fieldName]);
                });
                result.error = isPinValid(result.value) ? '' : 'pin_too_simple';
                return result;
            };

            // check if all input values are set and valid
            this.isDone = function () {
                return _squid.$util.every(Object.keys(_this.pinvalue), function (key) {
                    var inputVal = _this.pinvalue[key];

                    return isKeyValid(inputVal);
                });
            };

            // move cursor to the left or right based on direction
            this.moveCursor = function (currID, direction, clearCurrent) {
                var currentIndex = _this.fields.indexOf(currID);
                var currEle = document.getElementById(currID);
                if (clearCurrent) {
                    currEle.value = '';
                    _this.pinvalue[currID] = '';
                }

                var nextIndex = void 0;
                if (direction === 'left') {
                    nextIndex = currentIndex > 0 ? currentIndex - 1 : 0;
                }
                if (direction === 'right') {
                    nextIndex = currentIndex < _this.fields.length - 1 ? currentIndex + 1 : _this.fields.length - 1;
                }

                var nextID = _this.fields[nextIndex];
                if (nextID !== currID) {
                    var nextEle = document.getElementById(nextID);
                    nextEle.focus();
                } else {
                    // if user enters value into the last input - unfocus it to prevent entering more
                    currEle.blur();
                }
            };

            // reset all inputs / store and set focus on first element
            this.reset = function () {
                _this.fields.forEach(function (fieldName) {
                    _this.pinvalue[fieldName] = '';
                    var currentElement = document.getElementById(fieldName);

                    getWrapperElement(currentElement).removeClass(PASSWORD_DOT_CLASS);
                    getWrapperElement(currentElement).addClass(DEFAULT_DOT_CLASS);
                });
                // set focus to first elemnt
                var firstInput = document.getElementById(_this.fields[0]);

                if (firstInput) {
                    firstInput.focus();
                }
                _this.doingReset = false;
            };
        },
        populate: function populate() {
            var _this2 = this;

            this.reset();
            this.$on('resetPin', function () {
                _this2.doingReset = true;
                (0, _angular.$timeout)(function () {
                    return _this2.reset();
                }, DELAY);
            });
        }
    }
});


_squid.$Component;

_squid.$util;

_angular.$timeout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/mobile-pin/directive.js
// module id = ../node_modules/xo-ui-components/src/mobile-pin/directive.js
// module chunks = 0